const cartFragment = `
  id
  checkoutUrl
  totalQuantity
  discountAllocations {
    discountedAmount {
      amount
      currencyCode
    }
  }
  discountCodes {
    applicable
    code
  }
  note
  attributes {
    key
    value
  }
  cost {
    totalAmount {
      amount
      currencyCode
    }
  }
  lines(first: 50) {
    edges {
      node {
        id
        quantity
        merchandise {
        ... on ProductVariant {
          id
          title
          sku
          compareAtPriceV2 {
            amount
            currencyCode
          }
          priceV2 {
            amount
            currencyCode
          }
          selectedOptions {
            name
            value
          }
          product {
            id
            handle
          }
          image {
            id
            src
            altText
            width
            height
          }
        }
      }
      attributes {
        key
        value
      }
      cost {
        totalAmount {
          amount
        }
      }
      sellingPlanAllocation {
        sellingPlan {
          id
          name
        }
      }
    }
  }
}
`

const errorsFragment = `userErrors {
  field
  message
}`

export const createCartMutation = `mutation cartCreate {
  cartCreate {
    cart {
      ${cartFragment}
    }
    ${errorsFragment}
  }
}`

export const addLineItemsCartMutation = `mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
  cartLinesAdd(cartId: $cartId, lines: $lines) {
    cart {
      ${cartFragment}
    }
    ${errorsFragment}
  }
}`

export const updateLineItemsCartMutation = `mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
  cartLinesUpdate(cartId: $cartId, lines: $lines) {
    cart {
      ${cartFragment}
    }
    ${errorsFragment}
  }
}`

export const removeLineItemsCartMutation = `mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
  cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
    cart {
      ${cartFragment}
    }
    ${errorsFragment}
  }
}`

export const updateCartDiscountsMutation = `mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]!) {
  cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
    cart {
      ${cartFragment}
    }
    ${errorsFragment}
  }
}`

export const getCartQuery = `query getCart($cartId: ID!) {
  cart(id: $cartId) {
    ${cartFragment}
  }
}`

export const updateAttributes = `mutation cartAttributesUpdate($attributes: [AttributeInput!]!, $cartId: ID!) {
  cartAttributesUpdate(attributes: $attributes, cartId: $cartId) {
    cart {
      ${cartFragment}
    }
    userErrors {
      field
      message
    }
  }
}`
